import { ActivatedRouteSnapshot, RouterModule, Routes } from '@angular/router';

import { NgModule } from '@angular/core';
import { restrictIfFactory } from '../auth-o3/shared/restrict/restrict-if.factory';
import { CreateProductComponent } from './create-product/create-product.component';
import { DocumentComparisonComponent } from './product-capture-details/overview/document-comparison/document-comparison.component';
import { ProductCaptureDetailsComponent } from './product-capture-details/product-capture-details.component';
import { ProductCaptureComponent } from './product-capture.component';
import { CanDeactivateGuard } from './services/can-deactivate-guard';

const { restrictIfNot, oneOf } = restrictIfFactory();

const routes: Routes = [
  {
    path: '',
    component: ProductCaptureComponent,
    canActivate: [restrictIfNot('VIEW_PRODUCT_DATA')]
  },
  {
    path: 'view-details/:id',
    component: ProductCaptureDetailsComponent,
  },
  {
    path: 'create-product/:id',
    component: CreateProductComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [
      oneOf(
        restrictIfNot('NEW_PRODUCT', (route: ActivatedRouteSnapshot) => route.params.id === 'new'),
        restrictIfNot('CLONE_PRODUCT', (route: ActivatedRouteSnapshot) => route.params.id !== 'new')
      ),
    ]
  },
  {
    path: 'edit-product/:id',
    component: CreateProductComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [
      oneOf(
        restrictIfNot('EDIT_EXISTING_PRODUCTS'),
        restrictIfNot('VIEW_PRODUCT_DATA')
      )]
  },
  {
    path: 'diff-pdf/:title/:id',
    component: DocumentComparisonComponent,
    data: { title: 'PDF DIFF' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [CanDeactivateGuard],
})
export class ProductCaptureRoutingModule {}
